import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaseActionsComponent } from '@shared/components/base-actions/base-actions.component';
import { NgSelectModule } from '@shared/components/ng-select/ng-select.module';
import { WCAGLabelDirective } from '@shared/directives/wcag-label.directive';
import { ControlActionsService } from '@shared/services/control-actions.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-cra-payment-actions',
  templateUrl: './cra-payment-actions.component.html',
  styleUrls: ['./cra-payment-actions.component.scss'],
  imports: [NgSelectModule, FormsModule, TranslateModule, WCAGLabelDirective],
})
export class CraPaymentActionsComponent extends BaseActionsComponent implements OnInit {

  @Input() data: any;
  @Input() actionsList: any[] = [];
  @Output() successfullAction = new EventEmitter<boolean>();

  constructor(private controlActionsService: ControlActionsService,
  ) {
    super();
   }

  ngOnInit() {
    this.actionsList.forEach(
      option => option.workflowAction = this.translateService.instant(`COMMON.actionsLabel.${option.workflowAction}`));
  }

  public triggerActionController(action: any): void {
    this.resetSelection();
    switch (action.workflowAction) {

      case 'APPROVE':

        this.controlActionsService.craPaymentApprove(this.data)
        .pipe(
          takeUntil(this._destroy$),
        ).subscribe(
          data => {
            this.successfullAction.emit(true);
            this.resetSelection();
          },
        );

        break;

      case 'REJECT':

        this.controlActionsService.craPaymentReject({ id: this.data.id })
        .pipe(
          takeUntil(this._destroy$),
        ).subscribe(
          data => {
            this.successfullAction.emit(true);
          },
        );

        break;

      case 'SAVE':

        this.controlActionsService.craPaymentSave(this.data)
        .pipe(
          takeUntil(this._destroy$),
        ).subscribe(
          data => {
            this.successfullAction.emit(true);
            this.resetSelection();
          },
        );

        break;
    }

  }

}
